import {
  createContext,
  useContext,
  type Dispatch,
  type SetStateAction,
} from "react";

export const sidebarTabContext = createContext<{
  tab: string;
  setTab: Dispatch<SetStateAction<string>>;
} | null>(null);

export function useSidebarTab() {
  const context = useContext(sidebarTabContext);

  if (!context) {
    throw new Error("useSidebarTab must be used within SidebarTabProvider");
  }

  return context;
}
